import React, { useEffect, Suspense } from "react";

const loading = () => <div className=""></div>;

interface DefaultLayoutProps {
  layout: {
    layoutType: string;
    layoutWidth: string;
    leftSideBarTheme: string;
    leftSideBarType: string;
    showRightSidebar: boolean;
  };
  children?: any;
}

// Attributes set by dashboard layouts (TwoColumnLayout, VerticalLayout, etc.)
// that must be removed when entering auth pages to avoid CSS conflicts.
const DASHBOARD_BODY_ATTRS = [
  "data-layout-mode",
  "data-layout-width",
  "data-sidebar-color",
  "data-topbar-color",
  "data-sidebar-size",
  "data-layout-menu-position",
];

const DefaultLayout = (props: DefaultLayoutProps) => {
  useEffect(() => {
    if (!document.body) return;

    // Strip all dashboard layout attributes so auth-page CSS starts clean.
    DASHBOARD_BODY_ATTRS.forEach((attr) => document.body.removeAttribute(attr));

    document.body.classList.add("authentication-bg");

    return () => {
      document.body.classList.remove("authentication-bg");
    };
  }, []);

  // get the child view which we would like to render
  const children = props["children"] || null;

  return (
    <>
      <Suspense fallback={loading()}>{children}</Suspense>
    </>
  );
};
export default DefaultLayout;
